module.exports = __webpack_public_path__ + "img/vertical_4_7_8019.117acbd4.png";